// 今日热瓜 - 演示内容数据
// 说明：以下人物与节目均为虚构设定，仅作栏目内容呈现。

export type EventStatus = "developing" | "updating" | "reversed" | "done";

export const STATUS_META: Record<EventStatus, { label: string; icon: string; badge: string; dot: string }> = {
  developing: {
    label: "发酵中",
    icon: "ri-flashlight-fill",
    badge: "bg-brand-100 text-brand-700",
    dot: "bg-brand-500",
  },
  updating: {
    label: "持续更新",
    icon: "ri-refresh-line",
    badge: "bg-mint-100 text-mint-600",
    dot: "bg-mint-500",
  },
  reversed: {
    label: "已反转",
    icon: "ri-arrow-left-right-line",
    badge: "bg-rose-100 text-rose-600",
    dot: "bg-rose-500",
  },
  done: {
    label: "已收尾",
    icon: "ri-flag-line",
    badge: "bg-paper-100 text-ink-600",
    dot: "bg-ink-400",
  },
};

export interface KeyNode {
  time: string;
  text: string;
  tag: string;
}

export interface GossipEvent {
  id: string;
  title: string;
  category: string;
  status: EventStatus;
  heat: number;
  views: string;
  updated: string;
  summary: string;
  nodes: KeyNode[];
}

export const EVENTS: GossipEvent[] = [
  {
    id: "e1",
    title: "歌手林屿演唱会“对口型”争议发酵，主办方连夜声明",
    category: "娱乐现场",
    status: "developing",
    heat: 96,
    views: "1284万",
    updated: "18 分钟前",
    summary:
      "话题发酵已进入第三天：先是现场返图被逐帧比对，随后多个视角饭拍流出，舆论从“舞台失误”一路滑向“假唱”讨论，主办方深夜发声愿配合核查，但只回应了音轨来源，未正面回应口型，反转窗口仍在打开。",
    nodes: [
      { time: "第 1 天 19:40", text: "首发质疑帖指出现场收音与人声画面不同步，阅读量两小时破千万。", tag: "首次发酵" },
      { time: "第 2 天 10:15", text: "多个高清饭拍视角流出，比对各段副歌口型，讨论冲上热搜前三。", tag: "二次爆料" },
      { time: "第 2 天 23:50", text: "主办方发布声明称将配合专业机构核查音轨，未对“假唱”一词正面回应。", tag: "官方回应" },
      { time: "第 3 天 09:00", text: "疑似彩排无垫音视频在社交平台疯转，舆论再分两派。", tag: "最新进展" },
    ],
  },
  {
    id: "e2",
    title: "恋综CP《落日信箱》时间线对不上，网友复盘坐实剪辑反转",
    category: "综艺圈",
    status: "reversed",
    heat: 91,
    views: "982万",
    updated: "2 小时前",
    summary:
      "从“甜到上头”到“全在演戏”只用了四天。网友以各期飞行表、同款穿搭路透与字幕日期逐条比对，发现两人所谓“分手后和解”节点早于公开时间线，节目组默许的“剧情向”剪辑被复盘实锤，二次爆料直接改写舆论走向。",
    nodes: [
      { time: "第 1 天", text: "大结局当晚“世纪和解”名场面刷屏，CP粉连夜建超话。", tag: "高光开局" },
      { time: "第 3 天", text: "热心网友翻出女方 3 月行程与男方被拍同城，时间线出现第一处矛盾。", tag: "细节破绽" },
      { time: "第 4 天", text: "某站复盘视频逐帧比对字幕与场记，结论直指“按剧本剪辑”。", tag: "反转坐实" },
      { time: "第 5 天", text: "节目组低调下架高光花絮，男女方团队均未再公开互动。", tag: "收尾" },
    ],
  },
  {
    id: "e3",
    title: "电竞选手转会传闻反转再反转，经纪人晒出全程记录",
    category: "体娱圈",
    status: "updating",
    heat: 87,
    views: "765万",
    updated: "40 分钟前",
    summary:
      "一纸“千万转会费”爆料让粉丝连夜吵翻天，随后当事人出面否认、聊天截图二次流出、俱乐部发官方公告……真真假假三天三个版本。最新一版，经纪人公开了与三家具乐部的接洽时间线，试图证明报价从未落地，但评论区仍在挖合同细节。",
    nodes: [
      { time: "第 1 天", text: "爆料账号称某选手签下千万级转会合同，评论区瞬间引爆。", tag: "初始爆料" },
      { time: "第 2 天", text: "选手本人在直播中否认，称“根本没谈成”，粉丝站随之降温。", tag: "第一波反转" },
      { time: "第 3 天", text: "疑似内部聊天记录流出，出现“另一家开更高价”的说法。", tag: "二次爆料" },
      { time: "今天 14:00", text: "经纪人公开三家具乐部接洽时间线，等待俱乐部官方最终确认。", tag: "最新进展" },
    ],
  },
  {
    id: "e4",
    title: "古装剧《长灯引》造型争议升级，原作者下场谈“还原度”",
    category: "影视剧集",
    status: "developing",
    heat: 78,
    views: "521万",
    updated: "1 小时前",
    summary:
      "路透造型被吐槽“货不对板”，话题从服化道一路烧到选角。就在剧粉与路人各执一词时，原著作者发文聊起“心中的人物还原度”，被解读为隔空回应，也让这场本属于妆造的争议迅速升温成书粉与剧粉的对垒。",
    nodes: [
      { time: "第 1 天", text: "开机路透流出，女主头饰与原著描述差异被集中吐槽。", tag: "争议起点" },
      { time: "第 2 天", text: "原著作者发文谈人物还原，未点名但被普遍解读为隔空回应。", tag: "作者下场" },
      { time: "第 3 天", text: "制片方放出试妆概念图试图挽回，剧粉书粉争论仍在继续。", tag: "持续更新" },
    ],
  },
  {
    id: "e5",
    title: "直播“卖惨带货”翻车实锤，多方通报还原事实经过",
    category: "互联网热梗",
    status: "done",
    heat: 72,
    views: "843万",
    updated: "昨天 21:30",
    summary:
      "一场“帮助果农清库存”的直播感动了数万网友，却被扒出所谓滞销果根本不存在。经过供货方、平台与属地监管部门的三方核实，事件全貌浮出水面：营销剧本被层层拆穿，账号已暂停直播，官方也给出处理结果，此瓜收尾。",
    nodes: [
      { time: "第 1 天", text: "直播间“清库存救果农”情节催泪，单场销售额破纪录。", tag: "事件爆发" },
      { time: "第 3 天", text: "当地果农集体回应“没有滞销”，供应链端首次出现矛盾。", tag: "实锤前兆" },
      { time: "第 5 天", text: "平台封禁相关账号，监管部门通报处理结果，事实经过完整还原。", tag: "官方收尾" },
    ],
  },
  {
    id: "e6",
    title: "女星周棠“隐婚”传闻反转，本人一句回应让狗仔沉默",
    category: "明星八卦",
    status: "reversed",
    heat: 84,
    views: "1106万",
    updated: "5 小时前",
    summary:
      "有媒体曝出女星周棠疑似隐婚，配图、时间线、“同框即同住”的分析贴满天飞，眼看要坐实。结果周棠本人在直播里一句话点破“那是我经纪人”，顺势展示了当天的行程手账，用最轻的方式完成了最强反转，反转当天路人口碑反而上涨。",
    nodes: [
      { time: "第 1 天", text: "八卦媒体放出同住分析，隐婚传闻以图文形式发酵。", tag: "传闻发酵" },
      { time: "第 2 天", text: "网友考古其多段采访，越挖越觉得“早有端倪”，热度到顶。", tag: "考古推波" },
      { time: "第 2 天 21:00", text: "周棠直播当场澄清，称是经纪人并非伴侣，并展示行程手账。", tag: "本人反转" },
      { time: "第 3 天", text: "澄清切片刷屏，话题从“隐婚”反转成“经纪人神似”。", tag: "口碑翻面" },
    ],
  },
];

export const RANKING: { title: string; heat: number; tag: string; up: boolean }[] = [
  { title: "演唱会对口型争议 主办方回应", heat: 96, tag: "爆", up: true },
  { title: "恋综CP时间线复盘 反转坐实", heat: 91, tag: "新", up: true },
  { title: "电竞选手转会 经纪人晒记录", heat: 87, tag: "热", up: true },
  { title: "女星周棠 隐婚传闻当场反转", heat: 84, tag: "爆", up: true },
  { title: "《长灯引》造型争议 原著下场", heat: 78, tag: "热", up: false },
  { title: "直播卖惨带货 官方通报收尾", heat: 72, tag: "实锤", up: false },
  { title: "新综艺阵容官宣 网友急催定档", heat: 66, tag: "热", up: true },
  { title: "经典IP翻拍 选角名单曝光", heat: 58, tag: "新", up: true },
];

export const TICKER: string[] = [
  "爆｜林屿演唱会事件发酵第 3 天，主办方表态愿配合核查",
  "反转｜《落日信箱》时间线复盘坐实，CP 粉连夜复盘",
  "更新｜电竞选手转会经纪人晒出接洽全程记录",
  "实锤｜直播卖惨带货多方通报还原经过，账号已停播",
  "热｜女星周棠隐婚传闻当场反转，经纪人被玩成梗",
  "官宣｜新一季音综阵容曝光，官微评论区催更刷屏",
];

export interface Editorial {
  id: string;
  title: string;
  category: string;
  excerpt: string;
  readTime: string;
  date: string;
  views: string;
  comment: string;
  thumb: string;
  hot?: boolean;
}

export const PICKS: Editorial[] = [
  {
    id: "p1",
    title: "一场“假唱”争议是怎么发酵成热搜风暴的？",
    category: "深度复盘",
    excerpt:
      "从一张返图到全民逐帧比对，热点事件通常在三处节点放大。我们拆解了这条传播链：首发质疑、二次爆料与官方回应的三次博弈。",
    readTime: "8 分钟",
    date: "今天 09:20",
    views: "312万",
    comment: "2.1万",
    thumb:
      "https://readdy.ai/api/search-image?query=Backstage%20of%20a%20grand%20concert%20stage%20with%20empty%20stage%20lighting%20in%20warm%20amber%20and%20deep%20red%20tones%2C%20hazy%20atmosphere%2C%20cinematic%20editorial%20photo%2C%20dramatic%20rim%20light%2C%20soft%20dust%20in%20air&width=800&height=560&seq=edit-fake-sing&orientation=landscape",
    hot: true,
  },
  {
    id: "p2",
    title: "反转为什么总在“第五天”？聊聊吃瓜传播的节奏感",
    category: "传播观察",
    excerpt:
      "回顾近期的反转事件，大多踩在同一种节奏上：爆发、考古、对线、澄清、翻面。我们把它画成一条曲线，看看舆论是怎么一步步被改写的。",
    readTime: "6 分钟",
    date: "昨天 18:00",
    views: "198万",
    comment: "1.4万",
    thumb:
      "https://readdy.ai/api/search-image?query=Newspaper%20clippings%20and%20phone%20screens%20showing%20breaking%20news%20headlines%20scattered%20on%20warm%20cream%20desk%2C%20editorial%20flat%20lay%2C%20warm%20amber%20lighting%2C%20analog%20newsroom%20mood&width=800&height=560&seq=edit-rumor-rhythm&orientation=landscape",
  },
  {
    id: "p3",
    title: "作者下场、剧组回应，一场造型争议的三方博弈",
    category: "影视观察",
    excerpt:
      "当改编剧的还原度被抬上桌，书粉、剧粉与作者各自的立场开始互相拉扯。我们整理了这条事件里“谁在说话、说了什么”的完整坐标。",
    readTime: "5 分钟",
    date: "前天 15:40",
    views: "142万",
    comment: "9600",
    thumb:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20costume%20with%20flowing%20silk%20fabric%20in%20warm%20terracotta%20and%20gold%20tones%20on%20paper%20background%2C%20editorial%20still%20life%2C%20soft%20directional%20lighting&width=800&height=560&seq=edit-costume-drama&orientation=landscape",
  },
  {
    id: "p4",
    title: "直播间的“眼泪”值多少钱？卖惨带货的前世今生",
    category: "商业观察",
    excerpt:
      "一场直播能把眼泪和销售额同时顶到峰值，也能在一周内让信任崩塌。我们从供应链聊到话术设计，还原卖惨带货如何被拆穿。",
    readTime: "7 分钟",
    date: "3 天前",
    views: "265万",
    comment: "1.8万",
    thumb:
      "https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20ring%20light%2C%20microphone%20and%20empty%20chair%20in%20warm%20red%20and%20cream%20tones%2C%20editorial%20mood%20photography%2C%20soft%20bokeh%20background&width=800&height=560&seq=edit-livestream-tears&orientation=landscape",
  },
  {
    id: "p5",
    title: "“隐婚”反转的教科书：用一句真话接住满天飞料",
    category: "公关拆解",
    excerpt:
      "同样是澄清，为什么有人越解释越被骂，有人一句话就翻面？我们拆了周棠那场回应：轻、准、带证据，三步完成口碑逆转。",
    readTime: "5 分钟",
    date: "4 天前",
    views: "121万",
    comment: "8300",
    thumb:
      "https://readdy.ai/api/search-image?query=Warm%20glowing%20table%20lamp%20and%20open%20notebook%20on%20desk%20with%20soft%20cream%20background%2C%20cozy%20late%20night%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=800&height=560&seq=edit-pr-reversal&orientation=landscape",
  },
  {
    id: "p6",
    title: "别急着站队：一份“追瓜不上头”的时间线阅读指南",
    category: "编辑部手记",
    excerpt:
      "热点越吵越凶时，冷静反而稀缺。我们给想追明白的读者整理了五个要点：看首发、看二次、看回应、看证据、最后再看情绪。",
    readTime: "4 分钟",
    date: "5 天前",
    views: "98万",
    comment: "5600",
    thumb:
      "https://readdy.ai/api/search-image?query=Stack%20of%20warm%20toned%20editorial%20magazines%20and%20reading%20glasses%20on%20cream%20table%2C%20soft%20morning%20light%2C%20journalism%20still%20life%20photography&width=800&height=560&seq=edit-media-guide&orientation=landscape",
  },
];

export interface ReversalStep {
  title: string;
  date: string;
  summary: string;
  evidence?: string;
}

export const REVERSAL = {
  eyebrow: "本周焦点反转",
  title: "《落日信箱》到底甜不甜：一场被时间线戳破的“世纪和解”",
  lead:
    "从刷屏的“世纪和解”到被复盘成“按剧本剪辑”，四天之内，一部恋综的叙事被网友用飞行表、同款路透和字幕日期逐条拆穿。我们顺着最新进度，把这场反转的关键节点、展开细节与舆论方向一次理清。",
  image:
    "https://readdy.ai/api/search-image?query=Chinese%20reality%20dating%20show%20set%20with%20warm%20string%20lights%20and%20two%20empty%20chairs%20at%20sunset%2C%20cinematic%20editorial%20photography%2C%20romantic%20amber%20and%20rose%20tones%2C%20soft%20grain&width=1200&height=760&seq=rev-story-dating&orientation=landscape",
  stats: { watch: "1284万人在看", update: "更新至第 5 天", verified: "3 处实锤节点" },
  timeline: [
    {
      title: "高光开局",
      date: "Day 1 · 大结局夜",
      summary: "男女主“分手三年后世纪和解”名场面刷屏，CP 超话一夜增粉数十万，弹幕全是“我就知道是真的”。",
    },
    {
      title: "细节破绽",
      date: "Day 3 · 考古开始",
      summary: "热心网友翻出女方三月行程与该男星同城路透，两人被拍时间早于节目所称的“重逢”节点。",
      evidence: "首处时间线矛盾出现，质疑声开始聚拢。",
    },
    {
      title: "复盘实锤",
      date: "Day 4 · 反转坐实",
      summary: "一支逐帧比对字幕与场记的复盘视频走红，指出多处画面为后期重剪与补录引导，结论直指“剧情向剪辑”。",
      evidence: "二次爆料在此引爆，热度单日上涨三倍。",
    },
    {
      title: "低调收尾",
      date: "Day 5 · 最新进度",
      summary: "节目组悄悄下架争议高光花絮，男女方团队暂停公开互动，评论区从“磕到了”翻成“看戏散场”。",
      evidence: "事件仍在持续更新，观众转向关注节目组回应口径。",
    },
  ],
};

export const CATEGORIES: { id: string; name: string; desc: string; count: number }[] = [
  { id: "star", name: "明星八卦", desc: "恋情、家庭、通告背后的真与假", count: 1268 },
  { id: "variety", name: "综艺圈", desc: "真人秀名场面与剧本疑云", count: 943 },
  { id: "drama", name: "影视剧集", desc: "选角、造型、番位与还原度", count: 1106 },
  { id: "stage", name: "娱乐现场", desc: "晚会、演唱会与舞台争议", count: 612 },
  { id: "sports", name: "体娱圈", desc: "选手转会与赛场内外花边", count: 478 },
  { id: "web", name: "互联网热梗", desc: "直播带货与全网冲浪名场面", count: 855 },
];

export const FAQS: { q: string; a: string }[] = [
  {
    q: "今日热瓜的“发酵中”是什么意思？",
    a: "指事件已经有公开的首次爆料与讨论基础，但关键方尚未给出完整回应，舆论仍在升温、方向未定。处在发酵中的瓜，我们会持续跟踪最新动静并更新到页面。",
  },
  {
    q: "“已反转”和“已收尾”有什么区别？",
    a: "已反转代表事件出现推翻或大幅修正此前叙事的证据或回应，舆论方向发生明显转向；已收尾则说明关键方已给出较完整回应或官方处理结果，短期内不太可能再有新料。",
  },
  {
    q: "我的“追瓜”收藏会一直保存吗？",
    a: "目前追瓜收藏保存在你当前浏览器的本地记录里，方便你回来接着看更新进度。后续若你希望跨设备同步并参与评论讨论，可以进一步接入后端账号体系。",
  },
  {
    q: "事件更新到什么程度才算“更新到最新”？",
    a: "我们以关键方公开回应、二次爆料或官方通报为节点刷新进度条，并在每张瓜卡的关键节点里标注最新一条的时间与内容，方便你顺着更新读下去。",
  },
  {
    q: "内容里的观点代表谁的立场？",
    a: "本站内容基于公开渠道整理呈现，力求还原时间线、细节与各方说法，不代表对任何当事人的立场判断。涉及具体当事人的是非，请以官方与本人公开回应为准。",
  },
];

export const TESTIMONIALS: { name: string; role: string; text: string }[] = [
  {
    name: "阿梨不熬夜",
    role: "追瓜三年的老粉",
    text: "最大的好处是有时间线。别的平台刷一条忘一条，这里把关键节点排成进度，我下午摸鱼点开就能跟上最新一步。",
  },
  {
    name: "一株仙人掌",
    role: "综艺剪辑观众",
    text: "反转那期的时间线复盘真的做得细，字幕、飞行表、路透全都标了出处，看完整个人都清醒了，站队之前先让我看看证据。",
  },
  {
    name: "吃瓜但不站队",
    role: "普通网友",
    text: "不追着情绪跑这点很加分。评论区吵得越凶，这里越冷静，把二次爆料的来龙去脉摆清楚，很适合我这种想追明白的人。",
  },
];